var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.functions,"value":_vm.value,"hide-details":!_vm.isRequired,"label":_vm.title,"filled":"","clearable":"","rules":_vm.rules},on:{"input":function($event){return _vm.$emit('input',$event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }